function getIntegrationsState(state) {
  return {
    ...state.integrations.xml,
    integrators: {
      ...state.integrations.xml.integrators,
      data: state.integrations.xml.integrators.data.map(it => ({
        id: it.idIntegrador,
        name: it.nombre,
        code: it.enableCompanyCode
      }))
    },
    loading: state.integrations.xml.loading || state.integrations.xml.activation.loading
  };
}

function getLeadsIntegrationState(state) {
  return {
    ...state.integrations.leads,
    integrators: {
      ...state.integrations.leads.integrators,
      data: state.integrations.leads.integrators.data.map(it => ({
        id: it.idIntegrador,
        name: it.nombre,
        code: it.enableCompanyCode,
        enableCUI: it.multipleCallbackURL
      }))
    },
    companyIntegrations: {
      ...state.integrations.leads.companyIntegrations,
      data: state.integrations.leads.companyIntegrations.data?.map(it => ({
        ...it,
        editable: it.type === 'SOLO_LECTURA'
      }))
    },
    loading: state.integrations.leads.loading || state.integrations.leads.activation.loading
  };
}

export { getIntegrationsState, getLeadsIntegrationState };
